import axios from 'axios';
import { IKitchensApi } from '../types/kitchen.types';
import { instance } from './instance';
import { stringifyParameters } from '../helpers';

const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

export const externalClientApi = {
  getNames: async (): Promise<{ id: number; name: string; code: string }[]> =>
    (await instance.get('/admin/external-client/names')).data.data,
};

export const kitchensApi: IKitchensApi = {
  getAllKitchenDeliveryConfig: async (params?: {
    isShadow?: string;
    externalClientId?: number;
  }) => {
    const query = new URLSearchParams();
    if (params?.isShadow) query.set('isShadow', params.isShadow);
    if (params?.externalClientId)
      query.set('externalClientId', String(params.externalClientId));
    const qs = query.toString();
    return (
      await instance.get(`/admin/kitchen-delivery-config${qs ? `?${qs}` : ''}`)
    ).data.data;
  },

  getAllKitchens: async (params?: {
    isShadow?: string;
    externalClientId?: string;
  }) => {
    const query = new URLSearchParams();
    if (params?.isShadow) query.set('isShadow', params.isShadow);
    if (params?.externalClientId)
      query.set('externalClientId', params.externalClientId);
    const qs = query.toString();
    return await instance.get(`/admin/kitchen/all${qs ? `?${qs}` : '/'}`);
  },

  getKitchen: async (id) => await instance.get(`/admin/kitchen/${id}/`),

  getPlusCode: async (lat, lng) =>
    await axios.get(
      `https://plus.codes/api?address=${lat},${lng}&ekey=${apiKey}`
    ),

  createKitchen: async (payload) =>
    await instance.post('/admin/kitchen/create/', payload),

  updateKitchen: async (payload, id) =>
    await instance.put(`/admin/kitchen/${id}/`, payload),

  inviteStaff: async (kitchenId, payload) =>
    await instance.post(`/kitchen/${kitchenId}/invites`, payload),

  getKitchenRequests: async (params) => {
    const payload = stringifyParameters(params);

    const data = await instance.get(`/admin/kitchen-requests/all/${payload}`);

    return data.data;
  },

  approveKitchenRequest: async (code) =>
    (await instance.post(`/admin/kitchen-requests/${code}/approve`)).data,
};

export const saveStaffBrands = async (
  kitchenId: number,
  staffId: number,
  brandIds: number[]
): Promise<{ staffId: number; brandIds: number[] }> => {
  const { data } = await instance.put(
    `/kitchen/${kitchenId}/fulfilment/staff/${staffId}/brands`,
    { brandIds }
  );

  return data.data;
};
